import { useTranslation } from 'react-i18next';

/**
 * Custom hook to change the language of the application.
 *
 * @returns {Function} A function to change the language.
 */
export function useLanguageChange(): { changeLanguage: (lng: string) => Promise<void> } {
  const { i18n } = useTranslation();

  /**
   * Changes the language of the application.
   *
   * @param {string}
   * @returns {Promise} A promise that resolves when the language is changed.
   * @example
   * changeLanguage('en'); // Changes the language to English
   * changeLanguage('mm'); // Changes the language to Myanmar
   * */
  const changeLanguage = async (lng: string): Promise<void> => {
    await i18n.changeLanguage(lng);
  };
  return { changeLanguage };
}
